import React from 'react';
import * as Format from '../../utils/format';

export default ({ tel }) => <a href={'sms://+'+tel}>{Format.telNumber(tel)}</a>
